import _ from 'lodash';

import { getCommonFields } from '_/components/Dashboard/Widgets/DashboardWidgets.commonFields.js';

export const getFields = (LatestEntriesWidget) => {
    const commonFields = getCommonFields(LatestEntriesWidget);

    const fields = [
        ...commonFields,

        {
            id: LatestEntriesWidget.widget.id + '|refresh_interval',
            inline: false,
            label: 'Data Refresh Interval',
            mutation: 'widget/UPDATE_WIDGET_PROPERTY',
            name: LatestEntriesWidget.widget.id + '|refresh_interval',
            optionsData: [
                {
                    id: 0,
                    text: "Don't refresh automatically.",
                },

                {
                    id: 1000,
                    text: 'Every second',
                },

                {
                    id: 5 * 1000,
                    text: 'Every 5 seconds',
                },

                {
                    id: 10 * 1000,
                    text: 'Every 10 seconds',
                },

                {
                    id: 30 * 1000,
                    text: 'Every 30 second',
                },

                {
                    id: 60 * 1000,
                    text: 'Every minute',
                },

                {
                    id: 5 * 60 * 1000,
                    text: 'Every 5 minutes',
                },
            ],
            relatedTableName: false,
            required: true,
            tooltip: 'Widget data refresh interval.',
            value: _.has(LatestEntriesWidget.widget, 'refresh_interval')
                ? LatestEntriesWidget.widget.refresh_interval
                : null,
            vueComponent: 'Relationship',
        },

        {
            disabled: !LatestEntriesWidget.imageFields.length > 0,
            id: LatestEntriesWidget.widget.id + '|image_field',
            inline: false,
            label: 'Image Field',
            mutation: 'widget/UPDATE_WIDGET_PROPERTY',
            name: LatestEntriesWidget.widget.id + '|image_field',
            optionsData:
                LatestEntriesWidget.imageFields.length > 0
                    ? LatestEntriesWidget.imageFields
                    : [{ id: null, text: null }],
            preselectFirst: true,
            relatedTableName: false,
            required: true,
            tooltip: 'Field to be used as entry image.',
            value: _.has(LatestEntriesWidget.metaData, 'image_field') ? LatestEntriesWidget.metaData.image_field : null,
            vueComponent: 'Relationship',
        },
    ];

    return fields;
};
